import { AiOutlineUser } from "react-icons/ai";
import { shortenString } from "@lib/helpers/StringHelper";
import { Tag, Typography } from "antd";
import IntlMessages from "@lib/helpers/IntlMessages";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { green, red } from "@ant-design/colors";
import { TiInfoLarge } from "react-icons/ti";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { CustomerName } from "@lib/components/MiniComponents/Others";
import { IoBusinessSharp } from "react-icons/io5";
import { AppListItemMetaProps } from "@lib/components/AppComponents/AppListNew";
import { SendByteWalletAddress } from "@lib/types";
import { walletAddressTypeImage } from "@lib/helpers/ColorHelper";

export const SidebarCustomerLeadDetailListItems = ({
  customerLead,
  isLoading,
}) => {
  if (isLoading) return [];
  return [
    {
      title: (
        <Typography.Text ellipsis>
          {customerLead?.firstName} {customerLead?.lastName}
        </Typography.Text>
      ),
      avatar: <AiOutlineUser />,
    },
    {
      title: (
        <CustomerName customer={customerLead?.customer} link size="small" />
      ),
      avatar: <IoBusinessSharp />,
    },
    {
      avatar: <>ID</>,
      title: (
        <Typography.Text ellipsis>
          <TableIdButton
            text={`#${shortenString(customerLead?.id, 20)}`}
            textToBeCopied={customerLead?.id}
          />
        </Typography.Text>
      ),
    },
    {
      avatar: <TiInfoLarge />,
      title: (
        <StyledFlex style={{ justifyContent: "space-between" }}>
          <IntlMessages id="common.accountStatus" />{" "}
          <Tag
            color={customerLead?.isDisabled ? red[7] : green[7]}
            style={{ margin: 0 }}
          >
            <IntlMessages
              id={
                customerLead?.isDisabled ? "common.disabled" : "common.enabled"
              }
            />
          </Tag>
        </StyledFlex>
      ),
    },
  ] as AppListItemMetaProps[];
};

type SidebarWalletAddressSummaryListItemsType = {
  sendByteWalletAddressData: SendByteWalletAddress[];
  isLoading: boolean;
};

export const SidebarSendByteWalletAddressSummaryListItems = ({
  sendByteWalletAddressData,
  isLoading,
}: SidebarWalletAddressSummaryListItemsType) => {
  if (isLoading) return [];

  return (
    (sendByteWalletAddressData?.map((item) => ({
      avatar: (
        <img
          src={walletAddressTypeImage(item.network)}
          style={{ maxHeight: "20px" }}
        />
      ),
      title: (
        <Typography.Text ellipsis>
          <TableIdButton
            text={`${shortenString(item.address, 18)}`}
            textToBeCopied={item.address}
          />
        </Typography.Text>
      ),
    })) as AppListItemMetaProps[]) || []
  );
};
